import { memo } from 'react';
import type { Difficulty } from '@codedrill/shared';

interface DifficultySelectorProps {
  value: Difficulty | null;
  onChange: (d: Difficulty | null) => void;
}

const DIFFICULTIES: { value: Difficulty; label: string }[] = [
  { value: 'beginner', label: 'beginner' },
  { value: 'intermediate', label: 'intermediate' },
  { value: 'advanced', label: 'advanced' },
];

const DifficultySelector = memo(function DifficultySelector({
  value,
  onChange,
}: DifficultySelectorProps) {
  return (
    <div className="lang-selector" role="group" aria-label="Select difficulty">
      <button
        className={`lang-btn ${value === null ? 'lang-btn--active' : ''}`}
        onClick={() => onChange(null)}
      >
        all
      </button>
      {DIFFICULTIES.map((d) => (
        <button
          key={d.value}
          className={`lang-btn ${value === d.value ? 'lang-btn--active' : ''}`}
          onClick={() => onChange(d.value)}
        >
          {d.label}
        </button>
      ))}
    </div>
  );
});

export default DifficultySelector;
